"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _portraitVideo = require("./portraitVideo");

var _portraitVideo2 = _interopRequireDefault(_portraitVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _portraitVideo2.default;